import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Junta classes condicionais e resolve conflitos do Tailwind (o último vence). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/**
 * Iniciais para o avatar. Duas letras no máximo: "Marcos Daghlawi" -> "MD".
 * Nome vazio devolve "?" para nunca renderizar um círculo mudo.
 */
export function initials(fullName: string): string {
  const parts = fullName
    .trim()
    .split(/\s+/)
    .filter((part) => part.length > 0)

  const first = parts.at(0)
  if (first === undefined) {
    return '?'
  }

  const last = parts.length > 1 ? parts.at(-1) : undefined
  const letters = last === undefined ? first.slice(0, 1) : `${first.slice(0, 1)}${last.slice(0, 1)}`

  return letters.toUpperCase()
}
